import VerticalMenu_ComboBoxInputNavigationComponent from '../components/VerticalMenuComboBox/viewer/skinComps/ComboBoxInputNavigation/ComboBoxInputNavigation.skin';
import VerticalMenu_ComboBoxInputNavigationController from '../components/VerticalMenuComboBox/viewer/VerticalMenuComboBox.controller';


const VerticalMenu_ComboBoxInputNavigation = {
  component: VerticalMenu_ComboBoxInputNavigationComponent,
  controller: VerticalMenu_ComboBoxInputNavigationController
};


export const components = {
  ['VerticalMenu_ComboBoxInputNavigation']: VerticalMenu_ComboBoxInputNavigation
};

